/**
 * Сериализация query-параметров по ТЗ API-07:
 * `?page=&page_size=&sort=field|-field&q=&filter[field]=v` (несколько значений — `filter[field][]=`).
 */
export type QueryParamValue = string | number | boolean | null | undefined;
export type QueryParams = Readonly<
  Record<
    string,
    QueryParamValue | readonly QueryParamValue[] | Readonly<Record<string, FilterValue>>
  >
>;
export type FilterValue = string | readonly string[];

function isRecord(value: unknown): value is Readonly<Record<string, unknown>> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function appendValue(search: URLSearchParams, key: string, value: unknown): void {
  if (value === null || value === undefined || value === '') return;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    search.append(key, String(value));
  }
}

export function serializeParams(params: Readonly<Record<string, unknown>>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      for (const item of value) appendValue(search, `${key}[]`, item);
    } else if (isRecord(value)) {
      for (const [nested, nestedValue] of Object.entries(value)) {
        const nestedKey = `${key}[${nested}]`;
        if (Array.isArray(nestedValue)) {
          for (const item of nestedValue) appendValue(search, `${nestedKey}[]`, item);
        } else {
          appendValue(search, nestedKey, nestedValue);
        }
      }
    } else {
      appendValue(search, key, value);
    }
  }
  return search.toString();
}
